export const ENVIRONMENTS = ['dev', 'staging', 'preprod', 'production'] as const;

export type Environment = (typeof ENVIRONMENTS)[number];

export type CatalogSection = 'tools' | 'environments';

export type LaunchProtocol = 'saml' | 'oidc' | 'url';

/**
 * Launcher tile schema v1 — published to SSM by keycloak-internal
 * `terraform/99_workforce_dashboard` (App catalog section).
 */
export type CatalogTileV1 = {
  id: string;
  clientId: string;
  label: string;
  section: CatalogSection;
  description: string;
  icon?: string;
  protocol: LaunchProtocol;
  /** Fully resolved launch URL from Keycloak. */
  launchUrl: string;
  entitlementPrefix: string;
  sortOrder: number;
  environment?: Environment;
};

/**
 * Runtime tile — schema v1 plus SPA display fields (`abbr` / `color`) and
 * optional `alwaysVisible` for hard-coded tiles (Google Workspace, Exchange).
 */
export type CatalogApp = CatalogTileV1 & {
  abbr: string;
  color: string;
  alwaysVisible?: boolean;
  /** Keycloak admin consoles: `…/admin-access` only, not `…/access` or parent group paths. */
  requiresAdminAccess?: boolean;
};

export type WorkforceSession = {
  name: string;
  email: string;
  /** Keycloak group paths, e.g. `app/gitlab/developers` */
  groups: string[];
  /** Epoch seconds, mirrors the `auth_time` token claim */
  authTime: number;
};
